import { type ReactNode } from "react";

import { Row } from "@tanstack/react-table";

import { ConfigurationViewConfig } from "./datatable-configuration-view/datatable-configuration-view";
import { DatatableList } from "./datatable-list/datatable-list-lazy";
import { DatatablePagination } from "./datatable-pagination";
import { DatatableShell } from "./datatable-shell";
import { DatatableRowData, DatatableRowDataWithCacheKey } from "./datatable-types";

export interface DatatableBodyProps<TData extends DatatableRowData> {
  config?: ConfigurationViewConfig;
  getRowPath?: (row: Row<DatatableRowDataWithCacheKey<TData>>) => string;
  onRowClick?: (row: Row<DatatableRowDataWithCacheKey<TData>>) => void;
  onRowHover?: (row: Row<DatatableRowDataWithCacheKey<TData>>) => void;
  isRowSelected?: (row: Row<DatatableRowDataWithCacheKey<TData>>) => boolean;
}

export function DatatableBody<TData extends DatatableRowData>({
  config,
  getRowPath,
  onRowClick,
  onRowHover,
  isRowSelected,
}: DatatableBodyProps<TData>): ReactNode {
  return (
    <DatatableShell config={config}>
      <DatatableList<TData>
        getRowPath={getRowPath}
        onRowClick={onRowClick}
        onRowHover={onRowHover}
        isRowSelected={isRowSelected}
        config={config}
      />
      {config?.totalRow}
      <DatatablePagination />
    </DatatableShell>
  );
}
